(function () {
/*
|--------------------------------------------------------------------------
| App.JS
|
| Import statements must go at the top before any other code
|--------------------------------------------------------------------------
*/ var $2eceed07ec9d6891$var$n = function n1() {
    return $2eceed07ec9d6891$var$n = Object.assign || function(n) {
        for(var t, i = 1, e = arguments.length; i < e; i++)for(var r in t = arguments[i])Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
        return n;
    }, $2eceed07ec9d6891$var$n.apply(this, arguments);
};
function $2eceed07ec9d6891$var$t(n, t, i) {
    if (i || 2 === arguments.length) for(var e, r = 0, a = t.length; r < a; r++)!e && r in t || (e || (e = Array.prototype.slice.call(t, 0, r)), e[r] = t[r]);
    return n.concat(e || Array.prototype.slice.call(t));
}
function $2eceed07ec9d6891$var$i(n) {
    return Array.prototype.slice.call(n);
}
function $2eceed07ec9d6891$var$e(n, t) {
    var i = Math.floor(n);
    return i === t || i + 1 === t ? n : t;
}
function $2eceed07ec9d6891$var$r() {
    return Date.now();
}
function $2eceed07ec9d6891$var$a(n, t, i) {
    if (t = "data-keen-slider-" + t, null === i) return n.removeAttribute(t);
    n.setAttribute(t, i || "");
}
function $2eceed07ec9d6891$var$o(n, t) {
    return t = t || document, "function" == typeof n && (n = n(t)), Array.isArray(n) ? n : "string" == typeof n ? $2eceed07ec9d6891$var$i(t.querySelectorAll(n)) : n instanceof HTMLElement ? [
        n
    ] : n instanceof NodeList ? $2eceed07ec9d6891$var$i(n) : [];
}
function $2eceed07ec9d6891$var$u(n) {
    n.raw && (n = n.raw), n.cancelable && !n.defaultPrevented && n.preventDefault();
}
function $2eceed07ec9d6891$var$s(n) {
    n.raw && (n = n.raw), n.stopPropagation && n.stopPropagation();
}
function $2eceed07ec9d6891$var$c() {
    var n = [];
    return {
        add: function add(t, i, e, r) {
            t.addListener ? t.addListener(e) : t.addEventListener(i, e, r), n.push([
                t,
                i,
                e,
                r
            ]);
        },
        input: function input(n, t, i, e) {
            this.add(n, t, function(n) {
                return function(t) {
                    t.nativeEvent && (t = t.nativeEvent);
                    var _$i = t.changedTouches || [], _$e = t.targetTouches || [], r = t.detail && t.detail.x ? t.detail : null;
                    return n({
                        id: r ? r.identifier ? r.identifier : "i" : _$e[0] ? _$e[0] ? _$e[0].identifier : "e" : "d",
                        idChanged: r ? r.identifier ? r.identifier : "i" : _$i[0] ? _$i[0] ? _$i[0].identifier : "e" : "d",
                        raw: t,
                        x: r && r.x ? r.x : _$e[0] ? _$e[0].screenX : r ? r.x : t.pageX,
                        y: r && r.y ? r.y : _$e[0] ? _$e[0].screenY : r ? r.y : t.pageY
                    });
                };
            }(i), e);
        },
        purge: function purge() {
            n.forEach(function(n) {
                n[0].removeListener ? n[0].removeListener(n[2]) : n[0].removeEventListener(n[1], n[2], n[3]);
            }), n = [];
        }
    };
}
function $2eceed07ec9d6891$var$d(n, t, i) {
    return Math.min(Math.max(n, t), i);
}
function $2eceed07ec9d6891$var$l(n) {
    return (n > 0 ? 1 : 0) - (n < 0 ? 1 : 0) || +n;
}
function $2eceed07ec9d6891$var$f(n) {
    var t = n.getBoundingClientRect();
    return {
        height: $2eceed07ec9d6891$var$e(t.height, n.offsetHeight),
        width: $2eceed07ec9d6891$var$e(t.width, n.offsetWidth)
    };
}
function $2eceed07ec9d6891$var$p(n, t, i, e) {
    var r = n && n[t];
    return null == r ? i : e && "function" == typeof r ? r() : r;
}
function $2eceed07ec9d6891$var$v(n) {
    return Math.round(1e6 * n) / 1e6;
}
function $2eceed07ec9d6891$var$h(n) {
    var t, i, e, r, a, o;
    function u(t) {
        o || (o = t), s(!0);
        var a = t - o;
        a > e && (a = e);
        var _$l = r[i];
        if (_$l[3] < a) return i++, u(t);
        var f = _$l[2], p = _$l[4], v = _$l[0], h = _$l[1] * (0, _$l[5])(0 === p ? 1 : (a - f) / p);
        if (h && n.track.to(v + h), a < e) return d();
        o = null, s(!1), c(null), n.emit("animationEnded");
    }
    function s(n) {
        t.active = n;
    }
    function c(n) {
        t.targetIdx = n;
    }
    function d() {
        var n;
        n = u, a = window.requestAnimationFrame(n);
    }
    function l() {
        var t;
        t = a, window.cancelAnimationFrame(t), s(!1), c(null), o && n.emit("animationStopped"), o = null;
    }
    return t = {
        active: !1,
        start: function start(t) {
            if (l(), n.track.details) {
                var a = 0, o = n.track.details.position;
                i = 0, e = 0, r = t.map(function(n) {
                    var _$t, i = Number(o), r = null !== (_$t = n.earlyExit) && void 0 !== _$t ? _$t : n.duration, u = n.easing, s = n.distance * u(r / n.duration) || 0;
                    o += s;
                    var _$c = e;
                    return e += r, a += s, [
                        i,
                        n.distance,
                        _$c,
                        e,
                        n.duration,
                        u
                    ];
                }), c(n.track.distToIdx(a)), d(), n.emit("animationStarted");
            }
        },
        stop: l,
        targetIdx: null
    };
}
function $2eceed07ec9d6891$var$m(n) {
    var i, e, a, o, u, s, c, f, h, m, g, b, x, k, y = 1 / 0, w = [], M = null, T = 0;
    function C(n) {
        _(T + n);
    }
    function E(n) {
        var t = z(T + n).abs;
        return D(t) ? t : null;
    }
    function z(n) {
        var i = Math.floor(Math.abs($2eceed07ec9d6891$var$v(n / e))), r = $2eceed07ec9d6891$var$v((n % e + e) % e);
        r === e && (r = 0);
        var a = $2eceed07ec9d6891$var$l(n), o = c.indexOf($2eceed07ec9d6891$var$t([], c, !0).reduce(function(n, t) {
            return Math.abs(t - r) < Math.abs(n - r) ? t : n;
        })), u = o;
        return a < 0 && i++, o === s && (u = 0, i += a > 0 ? 1 : -1), {
            abs: u + i * s * a,
            origin: o,
            rel: u
        };
    }
    function I(n, t, i) {
        var e;
        if (t || !S()) return A(n, i);
        if (!D(n)) return null;
        var r = z(null != i ? i : T), a = r.abs, o = n - r.rel, u = a + o;
        e = A(u);
        var c = A(u - s * $2eceed07ec9d6891$var$l(o));
        return (null !== c && Math.abs(c) < Math.abs(e) || null === e) && (e = c), $2eceed07ec9d6891$var$v(e);
    }
    function A(n, t) {
        if (null == t && (t = $2eceed07ec9d6891$var$v(T)), !D(n) || null === n) return null;
        n = Math.round(n);
        var i = z(t), r = i.abs, a = i.rel, o = i.origin, u = O(n), d = (t % e + e) % e, l = c[o], f = Math.floor((n - (r - a)) / s) * e;
        return $2eceed07ec9d6891$var$v(l - d - l + c[u] + f + (o === s ? e : 0));
    }
    function D(n) {
        return L(n) === n;
    }
    function L(n) {
        return $2eceed07ec9d6891$var$d(n, h, m);
    }
    function S() {
        return o.loop;
    }
    function O(n) {
        return (n % s + s) % s;
    }
    function _(t) {
        var i;
        i = t - T, w.push({
            distance: i,
            timestamp: $2eceed07ec9d6891$var$r()
        }), w.length > 6 && (w = w.slice(-6)), T = $2eceed07ec9d6891$var$v(t);
        var e = H().abs;
        if (e !== M) {
            var a = null !== M;
            M = e, a && n.emit("slideChanged");
        }
    }
    function H(t) {
        var r = t ? null : function() {
            if (s) {
                var _$n = S(), _$t = _$n ? (T % e + e) % e : T, i = (_$n ? T % e : T) - u[0][2], r = 0 - (i < 0 && _$n ? e - Math.abs(i) : i), c = 0, d = z(T), f = d.abs, p = d.rel, v = u[p][2], y = u.map(function(t, i) {
                    var a = r + c;
                    (a < 0 - t[0] || a > 1) && (a += (Math.abs(a) > e - 1 && _$n ? e : 0) * $2eceed07ec9d6891$var$l(-a));
                    var u = i - p, d = $2eceed07ec9d6891$var$l(u), h = u + f;
                    _$n && (-1 === d && a > v && (h += s), 1 === d && a < v && (h -= s), null !== g && h < g && (a += e), null !== b && h > b && (a -= e));
                    var m = a + t[0] + t[1], x = Math.max(a >= 0 && m <= 1 ? 1 : m < 0 || a > 1 ? 0 : a < 0 ? Math.min(1, (t[0] + a) / t[0]) : (1 - a) / t[0], 0);
                    return c += t[0] + t[1], {
                        abs: h,
                        distance: o.rtl ? -1 * a + 1 - t[0] : a,
                        portion: x,
                        size: t[0]
                    };
                });
                return f = L(f), p = O(f), {
                    abs: L(f),
                    length: a,
                    max: k,
                    maxIdx: m,
                    min: x,
                    minIdx: h,
                    position: T,
                    progress: _$n ? _$t / e : T / a,
                    rel: p,
                    slides: y,
                    slidesLength: e
                };
            }
        }();
        return i.details = r, n.emit("detailsChanged"), r;
    }
    return i = {
        absToRel: O,
        add: C,
        details: null,
        distToIdx: E,
        idxToDist: I,
        init: function init(t) {
            if (function() {
                if (o = n.options, u = (o.trackConfig || []).map(function(n) {
                    return [
                        $2eceed07ec9d6891$var$p(n, "size", 1),
                        $2eceed07ec9d6891$var$p(n, "spacing", 0),
                        $2eceed07ec9d6891$var$p(n, "origin", 0)
                    ];
                }), s = u.length) {
                    e = $2eceed07ec9d6891$var$v(u.reduce(function(n, t) {
                        return n + t[0] + t[1];
                    }, 0));
                    var _$t, i = s - 1;
                    a = $2eceed07ec9d6891$var$v(e + u[0][2] - u[i][0] - u[i][2] - u[i][1]), c = u.reduce(function(n, i) {
                        if (!n) return [
                            0
                        ];
                        var e = u[n.length - 1], r = n[n.length - 1] + (e[0] + e[2]) + e[1];
                        return r -= i[2], n[n.length - 1] > r && (r = n[n.length - 1]), r = $2eceed07ec9d6891$var$v(r), n.push(r), (!_$t || _$t < r) && (f = n.length - 1), _$t = r, n;
                    }, null), 0 === a && (f = 0), c.push($2eceed07ec9d6891$var$v(e));
                }
            }(), !s) return H(!0);
            var i;
            !function() {
                var _$t = n.options.range, i = n.options.loop;
                g = h = i ? $2eceed07ec9d6891$var$p(i, "min", -1 / 0) : 0, b = m = i ? $2eceed07ec9d6891$var$p(i, "max", y) : f;
                var e = $2eceed07ec9d6891$var$p(_$t, "min", null), r = $2eceed07ec9d6891$var$p(_$t, "max", null);
                null !== e && (h = e), null !== r && (m = r), x = h === -1 / 0 ? h : n.track.idxToDist(h || 0, !0, 0), k = m === y ? m : I(m, !0, 0), null === r && (b = m), $2eceed07ec9d6891$var$p(_$t, "align", !1) && m !== y && 0 === u[O(m)][2] && (k -= 1 - u[O(m)][0], m = E(k - T)), x = $2eceed07ec9d6891$var$v(x), k = $2eceed07ec9d6891$var$v(k);
            }(), i = t, Number(i) === i ? C(A(L(t))) : H();
        },
        to: _,
        velocity: function velocity() {
            var n = $2eceed07ec9d6891$var$r(), t = w.reduce(function(t, i) {
                var e = i.distance, _$r = i.timestamp;
                return n - _$r > 200 || ($2eceed07ec9d6891$var$l(e) !== $2eceed07ec9d6891$var$l(t.distance) && t.distance && (t = {
                    distance: 0,
                    lastTimestamp: 0,
                    time: 0
                }), t.time && (t.distance += e), t.lastTimestamp && (t.time += _$r - t.lastTimestamp), t.lastTimestamp = _$r), t;
            }, {
                distance: 0,
                lastTimestamp: 0,
                time: 0
            });
            return t.distance / t.time || 0;
        }
    };
}
function $2eceed07ec9d6891$var$g(n) {
    var t, i, e, r, a, o, u, s;
    function c(n) {
        return 2 * n;
    }
    function f(n) {
        return $2eceed07ec9d6891$var$d(n, u, s);
    }
    function p(n) {
        return 1 - Math.pow(1 - n, 3);
    }
    function v() {
        return e ? n.track.velocity() : 0;
    }
    function h() {
        b();
        var t = "free-snap" === n.options.mode, i = n.track, e = v();
        r = $2eceed07ec9d6891$var$l(e);
        var u = n.track.details, s = [];
        if (e || !t) {
            var d = m(e), h = d.dist, _$g = d.dur;
            if (_$g = c(_$g), h *= r, t) {
                var x = i.idxToDist(i.distToIdx(h), !0);
                x && (h = x);
            }
            s.push({
                distance: h,
                duration: _$g,
                easing: p
            });
            var k = u.position, y = k + h;
            if (y < a || y > o) {
                var w = y < a ? a - k : o - k, M = 0, T = e;
                if ($2eceed07ec9d6891$var$l(w) === r) {
                    var C = Math.min(Math.abs(w) / Math.abs(h), 1), E = function(n) {
                        return 1 - Math.pow(1 - n, 1 / 3);
                    }(C) * _$g;
                    s[0].earlyExit = E, T = e * (1 - C);
                } else s[0].earlyExit = 0, M += w;
                var z = m(T, 100), I = z.dist * r;
                n.options.rubberband && (s.push({
                    distance: I,
                    duration: c(z.dur),
                    easing: p
                }), s.push({
                    distance: -I + M,
                    duration: 500,
                    easing: p
                }));
            }
            n.animator.start(s);
        } else n.moveToIdx(f(u.abs), !0, {
            duration: 500,
            easing: function easing(n) {
                return 1 + --n * n * n * n * n;
            }
        });
    }
    function m(n, t) {
        void 0 === t && (t = 1e3);
        var i = 147e-9 + (n = Math.abs(n)) / t;
        return {
            dist: Math.pow(n, 2) / i,
            dur: n / i
        };
    }
    function g() {
        var t = n.track.details;
        t && (a = t.min, o = t.max, u = t.minIdx, s = t.maxIdx);
    }
    function b() {
        n.animator.stop();
    }
    n.on("updated", g), n.on("optionsChanged", g), n.on("created", g), n.on("dragStarted", function() {
        e = !1, b(), t = i = n.track.details.abs;
    }), n.on("dragChecked", function() {
        e = !0;
    }), n.on("dragEnded", function() {
        var e = n.options.mode;
        "snap" === e && function() {
            var e = n.track, r = n.track.details, u = r.position, s = $2eceed07ec9d6891$var$l(v());
            (u > o || u < a) && (s = 0);
            var c = t + s;
            0 === r.slides[e.absToRel(c)].portion && (c -= s), t !== i && (c = i), $2eceed07ec9d6891$var$l(e.idxToDist(c, !0)) !== s && (c += s), c = f(c);
            var d = e.idxToDist(c, !0);
            n.animator.start([
                {
                    distance: d,
                    duration: 500,
                    easing: function easing(n) {
                        return 1 + --n * n * n * n * n;
                    }
                }
            ]);
        }(), "free" !== e && "free-snap" !== e || h();
    }), n.on("dragged", function() {
        i = n.track.details.abs;
    });
}
function $2eceed07ec9d6891$var$b(n) {
    var t, i, e, r, a, f, p, v, h, m, g, b, x, k, y, w, M, T, C = $2eceed07ec9d6891$var$c();
    function E(t) {
        if (f && v === t.id) {
            var o = D(t);
            if (h) {
                if (!A(t)) return I(t);
                m = o, h = !1, n.emit("dragChecked");
            }
            if (w) return m = o;
            $2eceed07ec9d6891$var$u(t);
            var _$c = function(t) {
                if (M === -1 / 0 && T === 1 / 0) return t;
                var e = n.track.details, o = e.length, _$u = e.position, _$s = $2eceed07ec9d6891$var$d(t, M - _$u, T - _$u);
                if (0 === o) return 0;
                if (!n.options.rubberband) return _$s;
                if (_$u <= T && _$u >= M) return t;
                if (_$u < M && i > 0 || _$u > T && i < 0) return t;
                var _$c = (_$u < M ? _$u - M : _$u - T) / o, _$l = r * o, f = Math.abs(_$c * _$l), p = Math.max(0, 1 - f / a * 2);
                return p * p * t;
            }(p(m - o) / r * e);
            i = $2eceed07ec9d6891$var$l(_$c);
            var x = n.track.details.position;
            (x > M && x < T || x === M && i > 0 || x === T && i < 0) && $2eceed07ec9d6891$var$s(t), g += _$c, !b && Math.abs(g * r) > 5 && (b = !0), n.track.add(_$c), m = o, n.emit("dragged");
        }
    }
    function z(t) {
        !f && n.track.details && n.track.details.length && (g = 0, f = !0, b = !1, h = !0, v = t.id, A(t), m = D(t), n.emit("dragStarted"));
    }
    function I(t) {
        f && v === t.idChanged && (f = !1, n.emit("dragEnded"));
    }
    function A(n) {
        var t = L(), i = t ? n.y : n.x, e = t ? n.x : n.y, r = void 0 !== x && void 0 !== k && Math.abs(k - e) <= Math.abs(x - i);
        return x = i, k = e, r;
    }
    function D(n) {
        return L() ? n.y : n.x;
    }
    function L() {
        return n.options.vertical;
    }
    function S() {
        r = n.size, a = L() ? window.innerHeight : window.innerWidth;
        var t = n.track.details;
        t && (M = t.min, T = t.max);
    }
    function O(n) {
        b && ($2eceed07ec9d6891$var$s(n), $2eceed07ec9d6891$var$u(n));
    }
    function _() {
        if (C.purge(), n.options.drag && !n.options.disabled) {
            var i;
            i = n.options.dragSpeed || 1, p = "function" == typeof i ? i : function p(n) {
                return n * i;
            }, e = n.options.rtl ? -1 : 1, S(), t = n.container, function() {
                var _$n = "data-keen-slider-clickable";
                $2eceed07ec9d6891$var$o("[".concat(_$n, "]:not([").concat(_$n, "=false])"), t).map(function(n) {
                    C.add(n, "dragstart", $2eceed07ec9d6891$var$s), C.add(n, "mousedown", $2eceed07ec9d6891$var$s), C.add(n, "touchstart", $2eceed07ec9d6891$var$s);
                });
            }(), C.add(t, "dragstart", function(n) {
                $2eceed07ec9d6891$var$u(n);
            }), C.add(t, "click", O, {
                capture: !0
            }), C.input(t, "ksDragStart", z), C.input(t, "ksDrag", E), C.input(t, "ksDragEnd", I), C.input(t, "mousedown", z), C.input(t, "mousemove", E), C.input(t, "mouseleave", I), C.input(t, "mouseup", I), C.input(t, "touchstart", z, {
                passive: !0
            }), C.input(t, "touchmove", E, {
                passive: !1
            }), C.input(t, "touchend", I), C.input(t, "touchcancel", I), C.add(window, "wheel", function(n) {
                f && $2eceed07ec9d6891$var$u(n);
            });
            var r = "data-keen-slider-scrollable";
            $2eceed07ec9d6891$var$o("[".concat(r, "]:not([").concat(r, "=false])"), n.container).map(function(n) {
                return function(n) {
                    var t;
                    C.input(n, "touchstart", function(n) {
                        t = D(n), w = !0, y = !0;
                    }, {
                        passive: !0
                    }), C.input(n, "touchmove", function(i) {
                        var e = L(), r = e ? n.scrollHeight - n.clientHeight : n.scrollWidth - n.clientWidth, a = t - D(i), _$o = e ? n.scrollTop : n.scrollLeft, s = e && "scroll" === n.style.overflowY || !e && "scroll" === n.style.overflowX;
                        if (t = D(i), (a < 0 && _$o > 0 || a > 0 && _$o < r) && y && s) return w = !0;
                        y = !1, $2eceed07ec9d6891$var$u(i), w = !1;
                    }), C.input(n, "touchend", function() {
                        w = !1;
                    });
                }(n);
            });
        }
    }
    n.on("updated", S), n.on("optionsChanged", _), n.on("created", _), n.on("destroyed", C.purge);
}
function $2eceed07ec9d6891$var$x(n) {
    var t, i, e = null;
    function r(t, i, e) {
        n.animator.active ? o(t, i, e) : requestAnimationFrame(function() {
            return o(t, i, e);
        });
    }
    function a() {
        r(!1, !1, i);
    }
    function o(i, r, a) {
        var o = 0, u = n.size, _$d = n.track.details;
        if (_$d && t) {
            var _$l = _$d.slides;
            t.forEach(function(n, t) {
                if (i) !e && r && s(n, null, a), c(n, null, a);
                else {
                    if (!_$l[t]) return;
                    var _$d = _$l[t].size * u;
                    !e && r && s(n, _$d, a), c(n, _$l[t].distance * u - o, a), o += _$d;
                }
            });
        }
    }
    function u(t) {
        return "performance" === n.options.renderMode ? Math.round(t) : t;
    }
    function s(n, t, i) {
        var e = i ? "height" : "width";
        null !== t && (t = u(t) + "px"), n.style["min-" + e] = t, n.style["max-" + e] = t;
    }
    function c(n, t, i) {
        if (null !== t) {
            t = u(t);
            var e = i ? t : 0;
            t = "translate3d(".concat(i ? 0 : t, "px, ").concat(e, "px, 0)");
        }
        n.style.transform = t, n.style["-webkit-transform"] = t;
    }
    function d() {
        t && (o(!0, !0, i), t = null), n.on("detailsChanged", a, !0);
    }
    function l() {
        r(!1, !0, i);
    }
    function f() {
        d(), i = n.options.vertical, n.options.disabled || "custom" === n.options.renderMode || (e = "auto" === $2eceed07ec9d6891$var$p(n.options.slides, "perView", null), n.on("detailsChanged", a), (t = n.slides).length && l());
    }
    n.on("created", f), n.on("optionsChanged", f), n.on("beforeOptionsChanged", function() {
        d();
    }), n.on("updated", l), n.on("destroyed", d);
}
function $2eceed07ec9d6891$var$k(t, i) {
    return function(e) {
        var r, u, s, d, l, v, h = $2eceed07ec9d6891$var$c();
        function m(n) {
            var _$t;
            $2eceed07ec9d6891$var$a(e.container, "reverse", "rtl" !== (_$t = e.container, window.getComputedStyle(_$t, null).getPropertyValue("direction")) || n ? null : ""), $2eceed07ec9d6891$var$a(e.container, "v", e.options.vertical && !n ? "" : null), $2eceed07ec9d6891$var$a(e.container, "disabled", e.options.disabled && !n ? "" : null);
        }
        function g() {
            b() && M();
        }
        function b() {
            var _$t = null;
            if (d.forEach(function(n) {
                n.matches && (_$t = n.__media);
            }), _$t === r) return !1;
            r || e.emit("beforeOptionsChanged"), r = _$t;
            var i = _$t ? s.breakpoints[_$t] : s;
            return e.options = $2eceed07ec9d6891$var$n($2eceed07ec9d6891$var$n({}, s), i), m(), I(), A(), C(), !0;
        }
        function x(n) {
            var _$t = $2eceed07ec9d6891$var$f(n);
            return (e.options.vertical ? _$t.height : _$t.width) / e.size || 1;
        }
        function k() {
            return e.options.trackConfig.length;
        }
        function y(t) {
            for(var a in r = !1, s = $2eceed07ec9d6891$var$n($2eceed07ec9d6891$var$n({}, i), t), h.purge(), u = e.size, d = [], s.breakpoints || []){
                var _$o = window.matchMedia(a);
                _$o.__media = a, d.push(_$o), h.add(_$o, "change", g);
            }
            h.add(window, "orientationchange", z), h.add(window, "resize", E), b();
        }
        function w(n) {
            e.animator.stop();
            var _$t = e.track.details;
            e.track.init(null != n ? n : _$t ? _$t.abs : 0);
        }
        function M(n) {
            w(n), e.emit("optionsChanged");
        }
        function T(n, t) {
            if (n) return y(n), void M(t);
            I(), A();
            var i = k();
            C(), k() !== i ? M(t) : w(t), e.emit("updated");
        }
        function C() {
            var n = e.options.slides;
            if ("function" == typeof n) return e.options.trackConfig = n(e.size, e.slides);
            for(var _$t = e.slides, i = _$t.length, r = "number" == typeof n ? n : $2eceed07ec9d6891$var$p(n, "number", i, !0), a = [], _$o = $2eceed07ec9d6891$var$p(n, "perView", 1, !0), u = $2eceed07ec9d6891$var$p(n, "spacing", 0, !0) / e.size || 0, s = "auto" === _$o ? u : u / _$o, _$c = $2eceed07ec9d6891$var$p(n, "origin", "auto"), d = 0, l = 0; l < r; l++){
                var f = "auto" === _$o ? x(_$t[l]) : 1 / _$o - u + s, v = "center" === _$c ? .5 - f / 2 : "auto" === _$c ? 0 : _$c;
                a.push({
                    origin: v,
                    size: f,
                    spacing: u
                }), d += f;
            }
            if (d += u * (r - 1), "auto" === _$c && !e.options.loop && 1 !== _$o) {
                var h = 0;
                a.map(function(n) {
                    var _$t = d - h;
                    return h += n.size + u, _$t >= 1 || (n.origin = 1 - _$t - (d > 1 ? 0 : 1 - d)), n;
                });
            }
            e.options.trackConfig = a;
        }
        function E() {
            I();
            var n = e.size;
            e.options.disabled || n === u || (u = n, T());
        }
        function z() {
            E(), setTimeout(E, 500), setTimeout(E, 2e3);
        }
        function I() {
            var n = $2eceed07ec9d6891$var$f(e.container);
            e.size = (e.options.vertical ? n.height : n.width) || 1;
        }
        function A() {
            e.slides = $2eceed07ec9d6891$var$o(e.options.selector, e.container);
        }
        e.container = (v = $2eceed07ec9d6891$var$o(t, l || document)).length ? v[0] : null, e.destroy = function() {
            h.purge(), e.emit("destroyed"), m(!0);
        }, e.prev = function() {
            e.moveToIdx(e.track.details.abs - 1, !0);
        }, e.next = function() {
            e.moveToIdx(e.track.details.abs + 1, !0);
        }, e.update = T, y(e.options);
    };
}
var $2eceed07ec9d6891$export$2e2bcd8739ae039 = function y(n, i, e) {
    try {
        return function(n, t) {
            var _$i, _$e = {};
            return _$i = {
                emit: function emit(n) {
                    _$e[n] && _$e[n].forEach(function(n) {
                        n(_$i);
                    });
                    var _$t = _$i.options && _$i.options[n];
                    _$t && _$t(_$i);
                },
                moveToIdx: function moveToIdx(n, t, e) {
                    var r = _$i.track.idxToDist(n, t);
                    if (r) {
                        var a = _$i.options.defaultAnimation;
                        _$i.animator.start([
                            {
                                distance: r,
                                duration: $2eceed07ec9d6891$var$p(e || a, "duration", 500),
                                easing: $2eceed07ec9d6891$var$p(e || a, "easing", function(n) {
                                    return 1 + --n * n * n * n * n;
                                })
                            }
                        ]);
                    }
                },
                on: function on(n, t, i) {
                    void 0 === i && (i = !1), _$e[n] || (_$e[n] = []);
                    var r = _$e[n].indexOf(t);
                    r > -1 ? i && delete _$e[n][r] : i || _$e[n].push(t);
                },
                options: n
            }, function() {
                if (_$i.track = $2eceed07ec9d6891$var$m(_$i), _$i.animator = $2eceed07ec9d6891$var$h(_$i), t) for(var _$n = 0, _$e = t; _$n < _$e.length; _$n++)(0, _$e[_$n])(_$i);
                _$i.track.init(_$i.options.initial || 0), _$i.emit("created");
            }(), _$i;
        }(i, $2eceed07ec9d6891$var$t([
            $2eceed07ec9d6891$var$k(n, {
                drag: !0,
                mode: "snap",
                renderMode: "precision",
                rubberband: !0,
                selector: ".keen-slider__slide"
            }),
            $2eceed07ec9d6891$var$x,
            $2eceed07ec9d6891$var$b,
            $2eceed07ec9d6891$var$g
        ], e || [], !0));
    } catch (n) {
        console.error(n);
    }
};


function $1fddb41f226a4383$var$removeElement(elment) {
    elment.parentNode.removeChild(elment);
}
function $1fddb41f226a4383$var$createBtn(className) {
    var type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    var btn = document.createElement('button');
    btn.setAttribute('type', 'button');
    if (type) btn.setAttribute('aria-label', type);
    var classNames = className.split(' ');
    classNames.forEach(function(name) {
        return btn.classList.add(name);
    });
    return btn;
}
var $1fddb41f226a4383$export$e5383273bc7bedd = function(slider) {
    var createDots = function createDots() {
        container = document.createElement('fieldset');
        container.className = 'carousel--dots';
        container.role = 'radiogroup';
        slider.track.details.slides.forEach(function(_, idx) {
            var input = document.createElement('input');
            input.type = 'radio';
            input.name = 'keen--slider-dots';
            input.id = "keen-dot-".concat(idx);
            var label = document.createElement('label');
            label.setAttribute('for', input.id);
            input.addEventListener('change', function() {
                if (input.checked) slider.moveToIdx(idx);
            });
            container.appendChild(input);
            container.appendChild(label);
        });
        slider.container.parentNode.appendChild(container);
    };
    var updateDots = function updateDots() {
        var current = slider.track.details.rel;
        var inputs = container.querySelectorAll('input');
        if (inputs[current]) inputs[current].checked = true;
    };
    if (slider.slides.length <= 1) return;
    var container;
    slider.on('created', function() {
        createDots();
        updateDots();
    });
    slider.on('slideChanged', updateDots);
};
var $1fddb41f226a4383$export$80adc0c60c17ef1e = function(slider) {
    var arrowMarkup = function arrowMarkup(remove) {
        if (remove) {
            $1fddb41f226a4383$var$removeElement(arrowLeft);
            $1fddb41f226a4383$var$removeElement(arrowRight);
            return;
        }
        arrowLeft = $1fddb41f226a4383$var$createBtn('carousel--btn left disabled', 'Previous slide');
        arrowLeft.addEventListener('click', function() {
            return slider.prev();
        });
        arrowRight = $1fddb41f226a4383$var$createBtn('carousel--btn right', 'Next slide');
        arrowRight.addEventListener('click', function() {
            return slider.next();
        });
        wrapper.appendChild(arrowLeft);
        wrapper.appendChild(arrowRight);
    };
    var updateClasses = function updateClasses() {
        var slide = slider.track.details.rel;
        slide === 0 ? arrowLeft.classList.add('disabled') : arrowLeft.classList.remove('disabled');
        slide === slider.track.details.slides.length - 1 ? arrowRight.classList.add('disabled') : arrowRight.classList.remove('disabled');
        if (slider.track.details.maxIdx === slide) {
            arrowLeft.classList.remove('disabled');
            arrowRight.classList.add('disabled');
        }
    };
    var _slider_container;
    var wrapper = slider === null || slider === void 0 ? void 0 : (_slider_container = slider.container) === null || _slider_container === void 0 ? void 0 : _slider_container.nextElementSibling;
    var hasWrapper = wrapper === null || wrapper === void 0 ? void 0 : wrapper.classList.contains('js-slider-wrapper');
    if (!hasWrapper || slider.slides.length <= 1) return;
    var arrowLeft, arrowRight;
    var markup = function(remove) {
        return arrowMarkup(remove);
    };
    slider.on('created', function() {
        markup();
        updateClasses();
    });
    slider.on('optionsChanged', function() {
        markup(true);
        markup();
        updateClasses();
    });
    slider.on('slideChanged', function() {
        return updateClasses();
    });
    slider.on('destroyed', function() {
        return markup(true);
    });
};
var $1fddb41f226a4383$export$3ce976189ac304b7 = function(slider) {
    var clearNextTimeout = function clearNextTimeout() {
        clearTimeout(timeout);
    };
    var nextTimeout = function nextTimeout() {
        clearTimeout(timeout);
        if (mouseOver) return;
        timeout = setTimeout(function() {
            slider.next();
        }, 2000);
    };
    var timeout;
    var mouseOver = false;
    slider.on('created', function() {
        slider.container.addEventListener('mouseover', function() {
            mouseOver = true;
            clearNextTimeout();
        });
        slider.container.addEventListener('mouseout', function() {
            mouseOver = false;
            nextTimeout();
        });
        nextTimeout();
    });
    slider.on('dragStarted', clearNextTimeout);
    slider.on('animationEnded', nextTimeout);
    slider.on('updated', nextTimeout);
};
var $1fddb41f226a4383$export$cfdd767f5a513509 = function(slider) {
    if (slider.slides.length <= 1) return;
    document.addEventListener('keydown', function(param) {
        var key = param.key;
        if (!key) return;
        if (key === 'ArrowLeft') slider.prev();
        if (key === 'ArrowRight') slider.next();
    });
};


var $5fa64d72fbd6a557$var$initSlider = function() {
    var sliders = document.querySelectorAll('.keen-slider');
    if (!(sliders === null || sliders === void 0 ? void 0 : sliders.length)) return;
    var animation = {
        duration: 10000,
        easing: function(t) {
            return t;
        }
    };
    sliders.forEach(function(slider) {
        var config = {
            drag: slider.classList.contains('slider--grab'),
            loop: slider.classList.contains('slider--loop'),
            mode: slider.classList.contains('slider--snap') ? 'snap' : 'free',
            renderMode: 'performance',
            slides: {
                perView: slider.dataset.cols,
                spacing: 80
            }
        };
        if (slider.classList.contains('slider--auto')) {
            config.created = function(s) {
                return s.moveToIdx(5, true, animation);
            };
            config.updated = function(s) {
                return s.moveToIdx(s.track.details.abs + 5, true, animation);
            };
            config.animationEnded = function(s) {
                return s.moveToIdx(s.track.details.abs + 5, true, animation);
            };
        }
        new (0, $2eceed07ec9d6891$export$2e2bcd8739ae039)(slider, config, [
            (0, $1fddb41f226a4383$export$cfdd767f5a513509),
            (0, $1fddb41f226a4383$export$e5383273bc7bedd)
        ]);
    });
};
$5fa64d72fbd6a557$var$initSlider();


var $bfa893d0769c6e8c$var$spriteRender = function(theme) {
    fetch("/wp-content/themes/".concat(theme, "/dist/img/sprite.svg?v=14")).then(function(res) {
        return res.ok ? res.text() : null;
    }).then(function(sprite) {
        return sprite && (document.getElementById('website-sprite').innerHTML = sprite);
    });
};
var $bfa893d0769c6e8c$export$2e2bcd8739ae039 = $bfa893d0769c6e8c$var$spriteRender;


// const showVideo = (video) => ((video.style.opacity = 1), video.paused && video.play().catch(() => {}))
// export default showVideo
var $7cb46aee94ab23d6$var$videoControls = function() {
    document.querySelectorAll('video').forEach(function(video) {
        var btn = document.createElement('button');
        video.after(btn);
        btn.addEventListener('click', function() {
            video.muted = !video.muted;
            if (video.muted) video.setAttribute('muted', '');
            else video.removeAttribute('muted');
        });
    });
};
var $7cb46aee94ab23d6$export$2e2bcd8739ae039 = $7cb46aee94ab23d6$var$videoControls;


var $617e40c786b88f50$var$menuInit = function() {
    var navMenu = document.getElementById('js-aside');
    var navOpen = document.getElementById('js-aside-open');
    var navClose = document.getElementById('js-aside-close');
    if (!navOpen || !navClose || !navMenu) return;
    navOpen.addEventListener('click', function() {
        navMenu.setAttribute('aria-disabled', false);
    });
    navClose.addEventListener('click', function() {
        navMenu.setAttribute('aria-disabled', true);
    });
};
var $617e40c786b88f50$export$2e2bcd8739ae039 = $617e40c786b88f50$var$menuInit;


function $c2cfeed658375ef3$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $71e348100ec43b78$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $c2cfeed658375ef3$export$71511d61b312f219)(arr);
}


function $077f05a7dd5a7d1a$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $79f2bc22a0cfcadc$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $986d7e027c46ac1a$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c2cfeed658375ef3$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c2cfeed658375ef3$export$71511d61b312f219)(o, minLen);
}


function $68fa624b0058b215$export$71511d61b312f219(arr) {
    return (0, $71e348100ec43b78$export$71511d61b312f219)(arr) || (0, $077f05a7dd5a7d1a$export$71511d61b312f219)(arr) || (0, $986d7e027c46ac1a$export$71511d61b312f219)(arr) || (0, $79f2bc22a0cfcadc$export$71511d61b312f219)();
}


var $a81466a32461bc1f$var$filtersInit = function() {
    var _document_querySelectorAll;
    var layoutArchive = (_document_querySelectorAll = document.querySelectorAll('.layout--archive')) !== null && _document_querySelectorAll !== void 0 ? _document_querySelectorAll : null;
    layoutArchive && layoutArchive.forEach(function(archiveElm) {
        var _archiveElm_querySelector;
        var radioElm = (_archiveElm_querySelector = archiveElm.querySelector('.layout--radio')) !== null && _archiveElm_querySelector !== void 0 ? _archiveElm_querySelector : null;
        if (!radioElm) return;
        var _archiveElm_querySelector1;
        var gridElm = (_archiveElm_querySelector1 = archiveElm.querySelector('.layout--cards')) !== null && _archiveElm_querySelector1 !== void 0 ? _archiveElm_querySelector1 : null;
        var cardsElm = (0, $68fa624b0058b215$export$71511d61b312f219)(gridElm.children);
        radioElm.addEventListener('change', function(e) {
            gridElm.dataset.topic = e.target.value;
            cardsElm.forEach(function(cardElm) {
                var topics = cardElm.dataset.topics.split(' ');
                e.target.value === 'all' || topics.includes(e.target.value) ? cardElm.style.display = '' : cardElm.style.display = 'none';
            });
        });
    });
};
var $a81466a32461bc1f$export$2e2bcd8739ae039 = $a81466a32461bc1f$var$filtersInit;


var $f24550bb89c5aa8b$var$feefoInit = function() {
    var body = document.getElementsByTagName('body')[0];
    var merchantId = body.dataset.merchant;
    if (!merchantId) return;
    (function(w) {
        var feefoWidgetScript = document.createElement('script');
        feefoWidgetScript.setAttribute('async', 'async');
        feefoWidgetScript.setAttribute('src', '//register.feefo.com//feefo-widget-v2/js/feefo-widget.js');
        feefoWidgetScript.setAttribute('type', 'text/javascript');
        feefoWidgetScript.onload = function() {
            if (typeof w.feefoWidgetInstance === 'undefined') {
                if (typeof feefoWidget !== 'undefined') w.feefoWidgetInstance = feefoWidget(w.feefoWidgetInstanceConfig);
            }
        };
        w.feefoWidgetInstanceConfig = {
            assetUrl: '//register.feefo.com//feefo-widget-v2',
            debug: false,
            hosts: {
                api: 'api.feefo.com/api',
                widget: 'register.feefo.com',
                collector: 'collect.feefo.com'
            },
            merchantId: merchantId,
            protocol: 'https',
            source: 'javascript',
            tags: '',
            externalCta: '',
            versionDir: 'feefo-widget-v2',
            isMigratedMerchant: 'false'
        };
        w.FeefoWidgetSources = {
            onPage: 'LEGACY',
            slideOut: 'LEGACY',
            popupReviews: 'LEGACY',
            productStars: 'LEGACY',
            optionalProductStars: 'LEGACY',
            mediaGallery: 'LEGACY',
            serviceCarousel: 'LEGACY',
            questionDisplay: 'LEGACY',
            questionForm: 'LEGACY',
            aaeBadge: 'LEGACY',
            highlightedTopics: 'LEGACY',
            highlightedSnippets: 'LEGACY'
        };
        document.head.appendChild(feefoWidgetScript);
        var widgetsAppEnabled = false;
        if (widgetsAppEnabled) {
            var feefoWidgetsAppScript = document.createElement('script');
            feefoWidgetsAppScript.setAttribute('async', 'async');
            feefoWidgetsAppScript.setAttribute('src', "https://api.feefo.com/feefo-widgets-data/loader/widgets/".concat(merchantId));
            feefoWidgetsAppScript.setAttribute('type', 'text/javascript');
            document.head.appendChild(feefoWidgetsAppScript);
        }
    })(window);
};
var $f24550bb89c5aa8b$export$2e2bcd8739ae039 = $f24550bb89c5aa8b$var$feefoInit;


var $d72aec8dcb4dea64$var$products = function() {
    var productGrids = document.querySelectorAll('.grid--overflow-products');
    if (!productGrids.length) return;
    productGrids.forEach(function(productGrid) {
        var scrollArea = productGrid.parentElement;
        var wrapper = scrollArea.parentElement;
        var scrollPrev = wrapper.querySelector('.carousel--btn.prev');
        var scrollNext = wrapper.querySelector('.carousel--btn.next');
        if (!scrollArea || !scrollPrev || !scrollNext) return;
        var getScrollAmount = function() {
            var firstArticle = productGrid.querySelector('article');
            if (!firstArticle) return 0;
            var styles = window.getComputedStyle(productGrid);
            var gap = parseFloat(styles.columnGap) || 0;
            return firstArticle.offsetWidth + gap;
        };
        var updateButtons = function() {
            var maxScrollLeft = scrollArea.scrollWidth - scrollArea.clientWidth;
            scrollPrev.classList.toggle('is-disabled', scrollArea.scrollLeft <= 0);
            scrollNext.classList.toggle('is-disabled', scrollArea.scrollLeft >= maxScrollLeft - 1);
        };
        scrollPrev.addEventListener('click', function() {
            scrollArea.scrollBy({
                left: -getScrollAmount(),
                behavior: 'smooth'
            });
        });
        scrollNext.addEventListener('click', function() {
            scrollArea.scrollBy({
                left: getScrollAmount(),
                behavior: 'smooth'
            });
        });
        scrollArea.addEventListener('scroll', updateButtons);
        window.addEventListener('resize', updateButtons);
        updateButtons();
    });
};
var $d72aec8dcb4dea64$export$2e2bcd8739ae039 = $d72aec8dcb4dea64$var$products;


(0, $bfa893d0769c6e8c$export$2e2bcd8739ae039)('smg');
window.addEventListener('DOMContentLoaded', function() {
    (0, $7cb46aee94ab23d6$export$2e2bcd8739ae039)();
    (0, $a81466a32461bc1f$export$2e2bcd8739ae039)();
    (0, $d72aec8dcb4dea64$export$2e2bcd8739ae039)();
    (0, $f24550bb89c5aa8b$export$2e2bcd8739ae039)();
    (0, $617e40c786b88f50$export$2e2bcd8739ae039)();
});

})();
//# sourceMappingURL=app.js.map
